/** Add Ordinal suffix to int ("th","st","nd","rd")
 * curtesy of shopify
 * https://ecommerce.shopify.com/c/ecommerce-design/t/ordinal-number-in-javascript-1st-2nd-3rd-4th-29259
 *
 * @param { integer } n number to add suffix to
 * @returns { string } integer with suffix added
 *
 */
export function getOrdinal(n) {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  const ordinal = (s[(v - 20) % 10] || s[v] || s[0]);
  return `${n}${ordinal}`;
}



// WEBPACK FOOTER //
// ./src/utilities/formatters.js